export enum ProvisionOrdersTableColumnIdentifiers {
  Selected = "",
  PhoneNumber = "phoneNumber",
  CountryCode = "countryCode"
}
